module.exports = __webpack_public_path__ + "img/08-police.84820c85.svg";